import classNames from 'classnames'
import React from 'react'
import Dropdown from '../../Dropdown'
import { IDropdown } from '../../Dropdown/Dropdown'
import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { useAccessContext } from '../AccessProvider'
import { AccessAccount } from '../types'
import GuestBadge from './GuestBadge'

interface IUserDropdownProps extends IDropdown {
  resourceOwner?: AccessAccount
}

const UserDropdown: React.FunctionComponent<IUserDropdownProps> = ({
  resourceOwner,
  ...rest
}) => {
  const { users, userContributors, UserAvatar } = useAccessContext()
  const { t } = useUIComponentsContext()

  const renderItem = ({
    item,
    inButton
  }: {
    item: Record<string, any>
    inButton: boolean
  }) => {
    return (
      <div
        className={classNames({
          'py-2 pl-2 pr-5': inButton,
          'p-2': !inButton
        })}
      >
        <div className="flex items-center">
          <UserAvatar name={item.fullName} accountId={item.id} size={32} />

          <div className="flex items-center mx-2 min-w-0 flex-1 gap-1">
            <div className="flex flex-col items-start min-w-0 flex-1">
              <span className={'leading-tight text-sm truncate w-full'}>
                {item?.fullName}
              </span>
              {item?.jobTitle && (
                <span className="leading-tight text-2xs text-oxford-gray-400 truncate w-full">
                  {item?.jobTitle?.name}
                </span>
              )}
            </div>
            {item?.isGuest && <GuestBadge />}
          </div>
        </div>
      </div>
    )
  }

  return (
    <Dropdown
      data={users}
      textField="fullName"
      placeholder={`+ ${t?.('buttons.addUser')}`}
      renderItem={renderItem}
      dataParser={(data) =>
        data.filter(
          (user) =>
            user.id !== resourceOwner?.id &&
            !userContributors?.find(({ account }) => user.id === account.id)
        )
      }
      {...rest}
    />
  )
}

export default UserDropdown
